<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">External Forms</h1>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          item-key="id"
          mobile-break-point="1264"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideRemove
              @editItem="onEdit(item)"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <external-form-access-dialog
      :show="showAccessDialog"
      :value="selectedItem"
      @close="showAccessDialog = false"
    ></external-form-access-dialog>
    <v-row v-if="debug">
      <v-col>
        <code>{{ itineraryTaskStatuses }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>
</template>

<script>
import gql from "graphql-tag";
import DefaultListActions from "../DefaultListActions.vue";
import ExternalFormAccessDialog from "./ExternalFormAccessDialog.vue";
const LIST_QUERY = gql`
  query allExternalForms {
    externalForms {
      name
      code
      description
      isPaymentAmountRequired
    }
  }
`;
export default {
  components: { DefaultListActions, ExternalFormAccessDialog },
  name: "external-forms-list",

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Description",
          value: "description",
          name: "description",
        },

        {
          text: "Actions",
          value: "actions",
          name: "actions",
          align: "center",
        },
      ],
      showAccessDialog: false,
      selectedItem: null,
    };
  },
  computed: {
    items() {
      return this.externalForms ? [...this.externalForms] : [];
    },
  },
  methods: {
    onEdit(item) {
      this.selectedItem = { ...item };
      this.showAccessDialog = true;
    },
  },
  apollo: {
    externalForms: {
      query: LIST_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/external-forms/ExternalFormsList.vue